import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Alert, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "../../api/axios";
import { authReturnTo, rememberReturnTo } from "../../utils/authReturnTo";
import { auth0Config, isAuth0Enabled } from "../../auth/auth0Config";

function Auth0LoginButton({ returnTo }) {
  const { loginWithRedirect } = useAuth0();

  const handleAuth0Login = () => {
    rememberReturnTo(returnTo);
    loginWithRedirect({
      authorizationParams: {
        audience: auth0Config.audience,
        redirect_uri: window.location.origin
      },
      appState: { returnTo }
    });
  };

  return (
    <Button type="button" className="btn-cardora w-100" onClick={handleAuth0Login}>
      Entrar con Auth0
    </Button>
  );
}

function LoginForm() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const returnTo = authReturnTo(params.get("returnTo"), "/feed");
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    if (isSubmitting) return;
    setError("");
    setIsSubmitting(true);

    try {
      const { data } = await api.post("/auth/login", { ...form, email: form.email.trim() });
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      rememberReturnTo(returnTo);
      navigate(returnTo);
    } catch (requestError) {
      setError(requestError?.response?.status === 401
        ? 'Email o contraseña incorrectos. Puedes recuperar el acceso abajo.'
        : 'No pudimos conectar con Cardora. Intentalo de nuevo en unos instantes.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container className="page-band">
      <Row className="justify-content-center">
        <Col md={7} lg={5}>
          <Card className="cardora-card">
            <Card.Body>
              <h1 className="section-title mb-2">Entrar a Cardora</h1>
              <p className="muted-copy">Gestiona tu binder, buscadas, oportunidades y comunidades.</p>
              {error && <Alert variant="danger">{error}</Alert>}
              {isAuth0Enabled ? (
                <Auth0LoginButton returnTo={returnTo} />
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      value={form.email}
                      onChange={event => setForm({ ...form, email: event.target.value })}
                      autoComplete="email"
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="password">
                    <Form.Label>Contraseña</Form.Label>
                    <Form.Control
                      type="password"
                      value={form.password}
                      onChange={event => setForm({ ...form, password: event.target.value })}
                      autoComplete="current-password"
                      required
                    />
                  </Form.Group>
                  <Button type="submit" className="btn-cardora w-100" disabled={isSubmitting} aria-busy={isSubmitting}>
                    {isSubmitting ? 'Entrando...' : 'Entrar'}
                  </Button>
                  <p className="auth-legal-copy">
                    <Link to="/forgot-password">Olvidé mi contraseña</Link> · <Link to={"/register?returnTo=" + encodeURIComponent(returnTo)}>Crear cuenta</Link>
                  </p>
                </Form>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default LoginForm;
